/* ========================================
   Proadsy YMMT Vehicle Finder
   Loads real product data, 3 cascading selects,
   shows matching products inline.
   ======================================== */
(function() {
  'use strict';

  /* REMOVED 2026-10-21: injectLiveMobileFallback() — the 2026-05-03 injected mobile
     <style> (padding/title-size with !important) landed ~2.7s after paint and conflicted
     with the section's own mobile rules (proadsy-hero.liquid:550-580), causing a 0.16 CLS
     layout shift on the homepage. Section CSS now covers all these selectors. */

  var DATA_URL = null; // Set by Liquid in hero section
  var vehicleData = null;

  var yearSelect = document.getElementById('yearSelect');
  var makeSelect = document.getElementById('makeSelect');
  var modelSelect = document.getElementById('modelSelect');
  var findVehicleBtn = document.getElementById('findVehicleBtn');
  var finderMessage = document.getElementById('finderMessage');
  var resultsDiv = document.getElementById('ymmtResults');

  if (!yearSelect) return;

  // Find the data URL from script tag or a data attribute
  var scriptEl = document.querySelector('[data-vehicle-json]');
  if (scriptEl) {
    DATA_URL = scriptEl.getAttribute('data-vehicle-json');
  }

  function setOptions(el, values, placeholder) {
    el.innerHTML = '';
    var first = document.createElement('option');
    first.value = '';
    first.textContent = placeholder;
    el.appendChild(first);
    values.forEach(function(v) {
      var opt = document.createElement('option');
      opt.value = v;
      opt.textContent = v;
      el.appendChild(opt);
    });
  }

  var STORAGE_KEY = 'proadsy_ymmt';

  function saveSelection() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;
    if (year && make && model) {
      /* 2026-10-15: vehicle memory module writes both proadsy_vehicle + proadsy_ymmt */
      if (window.ProadsyVehicle) {
        ProadsyVehicle.set({ year: year, make: make, model: model });
        return;
      }
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ year: year, make: make, model: model }));
      } catch(e) {}
    }
  }

  function getSavedSelection() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) return JSON.parse(raw);
    } catch(e) {}
    if (window.ProadsyVehicle && typeof window.ProadsyVehicle.get === 'function') {
      return window.ProadsyVehicle.get();
    }
    return null;
  }

  function restoreSelection() {
    var saved = getSavedSelection();
    if (!saved || !vehicleData || !vehicleData.tree) return;

    /* Validate saved data still exists in current vehicle data */
    if (!vehicleData.tree[saved.year]) return;
    if (!vehicleData.tree[saved.year][saved.make]) return;
    if (!vehicleData.tree[saved.year][saved.make][saved.model]) return;

    /* Restore selects */
    yearSelect.value = saved.year;
    updateMakes();
    makeSelect.value = saved.make;
    updateModels();
    modelSelect.value = saved.model;
    showMatchingProducts();
    prewarmCurrentSelection();
  }

  function loadData() {
    if (!DATA_URL) {
      console.warn('YMMT: No data URL found');
      return;
    }
    fetch(DATA_URL)
      .then(function(r) { return r.json(); })
      .then(function(data) {
        vehicleData = data;
        initYears();
        restoreSelection();
      })
      .catch(function(err) {
        console.error('YMMT: Failed to load vehicle data', err);
      });
  }

  function slugifyVehiclePart(value) {
    return String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/\bmercedes-benz\b/g, 'mercedes')
      .replace(/\bchevrolet\b/g, 'chevrolet')
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');
  }

  function modelCollectionHandle(make, model) {
    var makeSlug = slugifyVehiclePart(make);
    var modelSlug = slugifyVehiclePart(model);
    if (!makeSlug || !modelSlug) return '';
    return makeSlug + '-' + modelSlug + '-fits';
  }

  /* 主推优先级: 前挡 windshield sunshade → umbrella → side window → cover → pet */
  function productPriority(product) {
    var handle = String(product && product[0] || '').toLowerCase();
    if (handle.indexOf('side-window') !== -1) return 2;
    if (handle.indexOf('umbrella') !== -1) return 1;
    if (handle.indexOf('sunshade') !== -1) return 0;
    if (handle.indexOf('pet') !== -1) return 4;
    if (handle.indexOf('cover') !== -1) return 3;
    return 5;
  }

  function sortedProductIndices(indices, products) {
    return (indices || []).slice().sort(function(a, b) {
      var availabilityDiff = Number(productAvailable(products[b])) - Number(productAvailable(products[a]));
      if (availabilityDiff !== 0) return availabilityDiff;
      var diff = productPriority(products[a]) - productPriority(products[b]);
      if (diff !== 0) return diff;
      /* 同优先级时有图的排前面，避免主卡裂图/空图 */
      var imgA = products[a] && products[a][2] ? 1 : 0;
      var imgB = products[b] && products[b][2] ? 1 : 0;
      return imgB - imgA;
    });
  }

  function productImageUrl(img, cdn) {
    if (!img) return '';
    var url = cdn + img;
    if (url.indexOf('cdn.shopify.com') !== -1) {
      url += (url.indexOf('?') === -1 ? '?' : '&') + 'width=480';
    }
    return url;
  }

  /* HEAD 验证 collection 存在 → 跳转；404/网络错误 → 降级到带 year 的搜索
     2026-10-29 (Krice t342u): 选完车型就在后台预热验证结果(validCache) + prefetch，点击时直接跳转；
     未预热时最多只等 800ms（原来 2500ms）。 */
  var validCache = {};
  var prefetched = {};
  function prewarmCollection(url) {
    if (!url || validCache.hasOwnProperty(url) || validCache[url + '#pending']) return;
    validCache[url + '#pending'] = true;
    try {
      if (!prefetched[url]) {
        prefetched[url] = true;
        var l = document.createElement('link');
        l.rel = 'prefetch'; l.href = url; l.as = 'document';
        document.head.appendChild(l);
      }
    } catch (e) {}
    fetch(url, { method: 'HEAD' })
      .then(function(r) { validCache[url] = !!r.ok; })
      .catch(function() { /* leave unknown */ })
      .then(function() { delete validCache[url + '#pending']; });
  }
  function navigateValidated(collectionUrl, fallbackUrl) {
    if (!collectionUrl) {
      window.location.href = fallbackUrl;
      return;
    }
    var done = false;
    function go(url) {
      if (done) return;
      done = true;
      window.location.href = url;
    }
    if (validCache.hasOwnProperty(collectionUrl)) {
      go(validCache[collectionUrl] ? collectionUrl : fallbackUrl);
      return;
    }
    var timer = setTimeout(function() { go(collectionUrl); }, 800);
    fetch(collectionUrl, { method: 'HEAD' })
      .then(function(r) {
        clearTimeout(timer);
        validCache[collectionUrl] = !!r.ok;
        go(r.ok ? collectionUrl : fallbackUrl);
      })
      .catch(function() {
        clearTimeout(timer);
        go(fallbackUrl);
      });
  }

  function initYears() {
    if (!vehicleData || !vehicleData.tree) return;
    var years = Object.keys(vehicleData.tree).sort(function(a, b) { return Number(b) - Number(a); });
    setOptions(yearSelect, years, 'Year');
    setOptions(makeSelect, [], 'Make');
    setOptions(modelSelect, [], 'Model');
    hideResults();
  }

  function updateMakes() {
    var year = yearSelect.value;
    if (!vehicleData || !vehicleData.tree[year]) {
      setOptions(makeSelect, [], 'Make');
      setOptions(modelSelect, [], 'Model');
      hideResults();
      return;
    }
    var makes = Object.keys(vehicleData.tree[year]).sort();
    setOptions(makeSelect, makes, 'Make');
    setOptions(modelSelect, [], 'Model');
    hideResults();
  }

  function updateModels() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    if (!vehicleData || !vehicleData.tree[year] || !vehicleData.tree[year][make]) {
      setOptions(modelSelect, [], 'Model');
      hideResults();
      return;
    }
    var models = Object.keys(vehicleData.tree[year][make]).sort();
    setOptions(modelSelect, models, 'Model');
    hideResults();
  }

  function productAvailable(product) {
    return !!product && product[3] !== false;
  }

  function fitmentFeedbackUrl(feedbackType, productHandle) {
    var fields = {
      feedback_type: feedbackType || 'no_result',
      year: yearSelect.value,
      make: makeSelect.value,
      model: modelSelect.value,
      product: productHandle || ''
    };
    return '/pages/contact?' + Object.keys(fields).filter(function(key) {
      return fields[key];
    }).map(function(key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(fields[key]);
    }).join('&');
  }

  function collectionUrlForEntry(entry, year, make, model) {
    var collectionHandle = entry && (entry.collectionHandle || modelCollectionHandle(make, model));
    if (collectionHandle) return '/collections/' + collectionHandle;
    return '/search?q=' + encodeURIComponent(year + ' ' + make + ' ' + model) + '&type=product';
  }

  /* 车型选择后展示精简的双卡片结果 (sunshade + car cover) */
  function showMatchingProducts(trackEvent) {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;

    if (!year || !make || !model || !vehicleData) {
      hideResults();
      return;
    }
    if (trackEvent && window.ProadsyEvents) {
      window.ProadsyEvents.track('vehicle_selection_complete', { year: year, make: make, model: model });
    }

    var entry = vehicleData.tree[year] && vehicleData.tree[year][make] && vehicleData.tree[year][make][model];
    var vehicleName = year + ' ' + make + ' ' + model;
    if (!entry) {
      showNoMatch(vehicleName, trackEvent);
      return;
    }

    var cdn = vehicleData.cdn || '';
    var products = vehicleData.products || [];
    var types = [
      { key: 'sunshade', label: 'Sunshade', icon: '&#9728;&#65039;' },
      { key: 'car_cover', label: 'Car Cover', icon: '&#128737;&#65039;' }
    ];
    var primaryCards = [];
    var totalCount = 0;

    types.forEach(function(t) {
      var indices = sortedProductIndices(entry[t.key], products);
      if (!indices || indices.length === 0) return;
      totalCount += indices.length;
      var availableIndices = indices.filter(function(index) { return productAvailable(products[index]); });
      if (!availableIndices.length) return;
      var p = products[availableIndices[0]];
      primaryCards.push({
        handle: p[0],
        price: p[1],
        imgUrl: productImageUrl(p[2], cdn),
        label: t.label,
        icon: t.icon
      });
    });

    if (primaryCards.length === 0) {
      if (totalCount > 0) showOutOfStock(vehicleName, entry, year, make, model, trackEvent);
      else showNoMatch(vehicleName, trackEvent);
      return;
    }

    /* 2026-08-06 hit state: green check draw + result cards spring in (CSS in proadsy-hero.liquid) */
    var html = '<div class="ymmt-results-title">' +
      '<span class="ymmt-check" aria-hidden="true"><svg viewBox="0 0 20 20" fill="none"><circle cx="10" cy="10" r="8.5"/><path d="M5.8 10.3l2.7 2.7 5-5.8"/></svg></span>' +
      '<span>Fit found for ' + vehicleName +
      ' <span class="tag">EXACT FIT</span></span></div>';

    html += '<div class="ymmt-primary-cards">';
    primaryCards.forEach(function(card) {
      html += '<a href="/products/' + card.handle + '" class="ymmt-card">';
      html += '<div class="ymmt-card-img">';
      if (card.imgUrl) {
        html += '<img src="' + card.imgUrl + '" alt="' + vehicleName + ' ' + card.label + '" loading="lazy">';
      }
      html += '</div>';
      html += '<div class="ymmt-card-body">';
      html += '<div class="ymmt-card-type">' + card.icon + ' ' + card.label + '</div>';
      html += '<div class="ymmt-card-name">' + vehicleName + ' ' + card.label + '</div>';
      html += '<div class="ymmt-card-price">$' + card.price + '</div>';
      html += '<span class="ymmt-card-cta">Shop Now &rarr;</span>';
      html += '<span class="ymmt-card-trust">\u2713 Fit Guaranteed \u00b7 Free Returns</span>';
      html += '</div>';
      html += '</a>';
    });
    html += '</div>';

    if (totalCount > primaryCards.length) {
      var searchUrl = '/search?q=' + encodeURIComponent(vehicleName) + '&type=product';
      var allUrl = collectionUrlForEntry(entry, year, make, model);
      html += '<a href="' + allUrl + '" class="ymmt-see-all" data-ymmt-validated-link data-fallback-url="' + searchUrl + '">' +
        'See all ' + totalCount + ' products for your ' + vehicleName + ' &rarr;</a>';
    }

    resultsDiv.innerHTML = html;
    resultsDiv.classList.add('active');
    if (finderMessage) finderMessage.textContent = '';
  }

  function hideResults() {
    if (resultsDiv) {
      resultsDiv.classList.remove('active');
      resultsDiv.innerHTML = '';
    }
  }

  function showOutOfStock(vehicleName, entry, year, make, model, trackEvent) {
    if (!resultsDiv) return;
    var allUrl = collectionUrlForEntry(entry, year, make, model);
    if (trackEvent && window.ProadsyEvents) {
      window.ProadsyEvents.track('vehicle_out_of_stock', {
        year: year, make: make, model: model, collection: allUrl
      });
    }
    resultsDiv.innerHTML = '<div class="ymmt-no-match" style="padding:14px 16px;border:1px dashed rgba(255,77,0,.45);border-radius:12px;font-size:13.5px;line-height:1.5;color:#16161A">' +
      'Fit found for <b>' + vehicleName + '</b>, but the products in this selector are currently sold out. ' +
      '<a href="' + allUrl + '" style="color:#FF4D00;font-weight:700;text-decoration:underline;text-underline-offset:3px">View the fit collection</a> or ' +
      '<a href="' + fitmentFeedbackUrl('out_of_stock') + '" style="color:#FF4D00;font-weight:700;text-decoration:underline;text-underline-offset:3px">contact us</a>.</div>';
    resultsDiv.classList.add('active');
    if (finderMessage) finderMessage.textContent = '';
  }

  /* 2026-10-15 (V2 §09): explicit no-match state — never backfill with unrelated products */
  function showNoMatch(vehicleName, trackEvent) {
    if (!resultsDiv) return;
    if (trackEvent && window.ProadsyEvents) {
      window.ProadsyEvents.track('vehicle_no_result', {
        year: yearSelect.value, make: makeSelect.value, model: modelSelect.value
      });
    }
    resultsDiv.innerHTML = '<div class="ymmt-no-match" style="padding:14px 16px;border:1px dashed rgba(255,77,0,.45);border-radius:12px;font-size:13.5px;line-height:1.5;color:#16161A">' +
      'No exact-fit products for <b>' + vehicleName + '</b> yet. ' +
      '<a href="' + fitmentFeedbackUrl('no_result') + '" style="color:#FF4D00;font-weight:700;text-decoration:underline;text-underline-offset:3px">Contact us</a> and we&rsquo;ll confirm fitment for your vehicle.</div>';
    resultsDiv.classList.add('active');
    if (finderMessage) finderMessage.textContent = '';
  }

  function handleFindVehicle() {
    var year = yearSelect.value;
    var make = makeSelect.value;
    var model = modelSelect.value;

    if (!year || !make || !model) {
      if (finderMessage) finderMessage.textContent = 'Please select year, make, and model.';
      return;
    }

    var searchQuery = year + ' ' + make + ' ' + model;
    saveSelection();
    if (window.ProadsyEvents) {
      window.ProadsyEvents.track('vehicle_selection_complete', { year: year, make: make, model: model });
    }
    var fallbackUrl = '/search?q=' + encodeURIComponent(searchQuery) + '&type=product';
    var entry = vehicleData && vehicleData.tree && vehicleData.tree[year] && vehicleData.tree[year][make] && vehicleData.tree[year][make][model];
    var collectionHandle = entry && entry.collectionHandle ? entry.collectionHandle : modelCollectionHandle(make, model);
    var collectionUrl = collectionHandle ? '/collections/' + collectionHandle : '';
    /* 2026-10-29: immediate visual feedback so the tap never feels dead */
    if (findVehicleBtn && !findVehicleBtn.classList.contains('is-loading')) {
      findVehicleBtn.classList.add('is-loading');
      findVehicleBtn.setAttribute('aria-busy', 'true');
      findVehicleBtn.setAttribute('data-pa-label', findVehicleBtn.innerHTML);
      findVehicleBtn.innerHTML = '<span class="pa-spin" aria-hidden="true"></span> Finding your fit\u2026';
    }
    if (finderMessage) finderMessage.textContent = '';
    navigateValidated(collectionUrl, fallbackUrl);
  }

  /* restore the button if the page is restored from back/forward cache */
  window.addEventListener('pageshow', function() {
    if (findVehicleBtn && findVehicleBtn.classList.contains('is-loading')) {
      findVehicleBtn.classList.remove('is-loading');
      findVehicleBtn.removeAttribute('aria-busy');
      var lbl = findVehicleBtn.getAttribute('data-pa-label');
      if (lbl) findVehicleBtn.innerHTML = lbl;
    }
  });

  function prewarmCurrentSelection() {
    var year = yearSelect.value, make = makeSelect.value, model = modelSelect.value;
    if (!year || !make || !model || !vehicleData || !vehicleData.tree) return;
    var entry = vehicleData.tree[year] && vehicleData.tree[year][make] && vehicleData.tree[year][make][model];
    var h = entry && entry.collectionHandle ? entry.collectionHandle : modelCollectionHandle(make, model);
    if (h) prewarmCollection('/collections/' + h);
  }

  function trackFinderStart() {
    if (window.ProadsyEvents) window.ProadsyEvents.track('vehicle_finder_start', { source: 'homepage' });
  }

  yearSelect.addEventListener('change', function() {
    trackFinderStart();
    updateMakes();
  });
  makeSelect.addEventListener('change', function() {
    trackFinderStart();
    updateModels();
  });
  modelSelect.addEventListener('change', function() {
    trackFinderStart();
    showMatchingProducts(true);
    saveSelection();
    prewarmCurrentSelection();
  });
  if (findVehicleBtn) findVehicleBtn.addEventListener('click', handleFindVehicle);
  var notListedLink = document.getElementById('vehicleNotListed');
  if (notListedLink) {
    notListedLink.addEventListener('click', function() {
      notListedLink.href = fitmentFeedbackUrl('no_result');
    });
  }

  /* "See all" 链接拦截：HEAD 验证 collection，404 降级到搜索 */
  if (resultsDiv) {
    resultsDiv.addEventListener('click', function(e) {
      var link = e.target && e.target.closest ? e.target.closest('[data-ymmt-validated-link]') : null;
      if (!link) return;
      e.preventDefault();
      navigateValidated(link.getAttribute('href'), link.getAttribute('data-fallback-url') || link.getAttribute('href'));
    });
  }

  // Load data
  loadData();
})();
